<!--
 * @Author: your name
 * @Date: 2020-07-01 15:01:31
 * @LastEditTime: 2020-08-11 16:32:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\insurance\insurance.vue
--> 

<template>
  <div class="insurance-wrap">
    <div style="height:calc(100% + 1px);">
      <div class="insurance-back"></div>
      <div class="insurance-top">
        <div class="insurance-top-bg">
          <div>房屋卡号: {{cardCode}}</div>
          <div>房屋地址: {{houseInfo.building_name}}{{houseInfo.unit_number}}-{{houseInfo.hourse_number}}</div>
          <div>跑漏险保费: {{insuranceInfo.leakage_risk_fee}}元</div>
          <div>办理时间: {{date}}</div>
          <div>生效时间: {{effectiveDate}}</div>
        </div>
      </div>
      <div class="insurance-bottom">
        <div>被保人信息:</div>
        <div>姓名:</div>
        <div class="insurance-bottom-username">
          <input type="text" placeholder="请输入被保人姓名" v-model="userName" readonly="readonly"/>
        </div>
        <div>手机号:</div>
        <div>
          <input type="text" placeholder="请输入被保人手机号" v-model="phone" />
        </div>
        <div>身份证:</div>
        <div>
          <input type="text" placeholder="请输入被保人身份证号码" v-model="idCode" />
        </div>
      </div>
      <div class="insurance-holder">
        <div>投保人信息:</div>
        <div>姓名:</div>
        <div>
          <input type="text" placeholder="请输入投保人姓名" v-model="userName1" />
        </div>
        <div>手机号:</div>
        <div>
          <input type="text" placeholder="请输入投保人手机号" v-model="phone1" />
        </div>
      </div>
      <div class="insurance-button">
        <div>
          <el-button type="primary" style="background: rgba(0,123,131,1);" @click="payMent">确认</el-button>
        </div>
        <div>
          <el-button type="primary" style="background:rgba(0,123,131,0.1); border:1px solid rgba(0,123,131,1);color:rgba(0,123,131,1)" @click="houseExit">取消</el-button>
        </div>
      </div>
      <div class="mark-hint" v-if="markFlag">
        <div>
          <div style="text-align: right;padding:0.1rem 0.15rem;color:#AAAAAA"><i class="iconfont iconguanbi" @click="markFlag = false"></i></div>
          <div style="color:#007B83;margin-top:0.14rem">
            <div>
              <div>{{textHint}}</div>
              <div>请重新检查您的信息~</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "insurance",
  data() {
    return {
      cardCode: "", // 供热卡号
      phone: "", // 被保人电话
      userName: "",// 被保人姓名
      phone1: "", // 投保人电话
      userName1: "",// 投保人姓名
      idCode: "",// 身份证号
      houseInfo: "", // 房屋信息
      date: moment().format("YYYY年MM月DD日"),
      effectiveDate:moment().add(2,'days').format("YYYY年MM月DD日"),
      payFlag: "", //true 取暖费 false 跑漏险
      insuranceInfo: "", // 跑漏险信息
      areaCost: "", // 取暖费
      order_num: "", //订单编号
      loading: true,
      markFlag: false,
      textHint: "",// 文字提示
      payData:{},// 缴费参数信息
    };
  },

  methods: {
    // 查看房屋信息
    async getHouseInfo() {
      const houseRes = await this.$http.get(
        this.$url.globalurl + "/wxHouseInfo",
        {
          data: {
            cardCode: this.cardCode
          }
        }
      );
      this.houseInfo = houseRes.result;
    },
    // 查看跑漏险金额
    async getInsuranceMoney() {
      const customer_id = 1;
      const InsuranceRes = await this.$http.get(
        this.$url.globalurl + `/systemConfig/${sessionStorage.getItem('customer_id')}`
      );
      this.insuranceInfo = InsuranceRes.result[0];
    },
    // 取消保险缴费
    houseExit() {
      if (this.payFlag) {
        this.$router.replace({
          name: "searchResult",
          query: {
            cardCode: this.cardCode,
            phone: this.phone
          }
        });
      } else {
        this.$router.replace({
          name: "index"
        });
      }
    },
    //缴费成功
    async payMent() {
      if(!this.phone){
        this.markFlag = true;
        return this.textHint = '抱歉，被保人手机号码未填写'
      }
      if(!this.idCode){
        this.markFlag = true;
        return this.textHint = '抱歉，被保人身份证号码未填写'
      }
      if(!this.userName1){
        this.markFlag = true;
        return this.textHint = '抱歉，投保人姓名未填写'
      }
      if(!this.phone1){
        this.markFlag = true;
        return this.textHint = '抱歉，投保人的手机号码未填写'
      }
      if(!(/^1[3456789]\d{9}$/.test(this.phone))){
        this.markFlag = true;
        return this.textHint = '抱歉，您的被保人手机号码有误'
      }
      if(!/^[1-9]\d{7}((0\d)|bai(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(this.idCode)){
        this.markFlag = true;
        return this.textHint = '抱歉，您的身份证号码有误'
      }
      if(!(/^[\u4E00-\u9FA5]{2,4}$/.test(this.userName1))){
        this.markFlag = true;
        return this.textHint = '抱歉，您的姓名填写有误'
      }
      if(!(/^1[3456789]\d{9}$/.test(this.phone1))){
        this.markFlag = true;
        return this.textHint = '抱歉，您的投保人手机号码有误'
      }
      this.payFlag ? this.payHeating() : this.payInsurance();
    },
    // 供暖缴费
    async payHeating() {
          this.$router.replace({
            name: "userAgreement",
            query: {
              areaCost: this.areaCost,
              insuranceMoney: this.insuranceInfo.leakage_risk_fee,
              houseInfo: this.houseInfo,
              payFlag:true,
              payData:{
                phone: this.phone,
                id_card_number: this.idCode,
                owner_phone: this.phone1,
                owner_name: this.userName1,
                card_number: this.cardCode,
                pay_heating: 1,
                pay_risk: 1
              }
            }
          });
    },
    // 跑漏险缴费
    async payInsurance() {
          this.$router.replace({
            name: "userAgreement",
            query: {
              insuranceMoney: this.insuranceInfo.leakage_risk_fee,
              houseInfo: this.houseInfo,
              payFlag:false,
              payData:{
                phone: this.phone,
                areaCost:this.areaCost,
                id_card_number: this.idCode,
                owner_phone: this.phone1,
                owner_name: this.userName1,
                card_number: this.cardCode,
                pay_risk: 1
              }
            }
          });
    },
  },

  mounted() {
    if (this.$route.query) {
      this.cardCode = this.$route.query.cardCode;
      this.phone = this.$route.query.phone;
      this.areaCost = this.$route.query.areaCost;
      this.payFlag = this.$route.query.payFlag;
      this.userName = this.$route.query.userName.split("").map((item, index) =>  index % 2 == 0?"*":item).join("");
      this.getHouseInfo();
      this.getInsuranceMoney();
    }
    document.title = "办理房屋跑漏险";
  }
};
</script>

<style lang="scss" scoped>
@import url(insurance.scss);
</style>
